import { getQueryParam } from '../../../../utils/date'
//自定义事件处理
export default {
  methods: {
    /**
     * 邮件特殊地址审批
     */
    initApprovePage(){
      const idListStr = getQueryParam('idList');
      this.currentApprover = getQueryParam('userNo');
      let idList = idListStr ? JSON.parse(idListStr).map(id => Number(id)) : [];
      let param = { idList: idList};
      this.getRejectApproveDetail(param);
    },

    /**
     * 审批详情
     * @param param
     */
    getRejectApproveDetail(param){
      this.$showLoading();
      this.$store.dispatch(this.store + 'detailInfo', param).then(() => {
        let res = this.$store.state[this.modName].detailInfoObj;
        if (res.code == 200){
          let data = res.obj;
          this.rejectInfoList = data || [];
          // 审批结果不为00（待审批）时，禁用审批表单
          let filterStatus = (data || []).filter(item=>item.approveResultNo == '00');
          this.isEditFlag = filterStatus.length > 0 ? false : true;
          // 如果已审批，将审批结果和意见回显到表单
          if (this.isEditFlag) {
            this.approvalForm.approveResultNo = data[0].approveResultNo;
            this.approvalForm.remark = data[0].remark || '';
          }
        }
      }).finally(()=>{
        this.$hideLoading();
      })
    },

    /**
     * 审批确认
     */
    handleApprove(){
      this.$showLoading();
      let idList = (this.rejectInfoList || []).map(item => Number(item.id));
      let param = {
        idList: idList,
        approveResultNo: this.approvalForm.approveResultNo,
        remark: this.approvalForm.remark,
        approverUserNo: this.currentApprover
      }
      this.$store.dispatch(this.store + 'submitApproval', param).then(() => {
        let res = this.$store.state[this.modName].submitApprovalObj;
        if (res.code == 200){
          this.isEditFlag = true;
          let detailParam = {
            idList: idList
          }
          this.getRejectApproveDetail(detailParam);
          this.$message.success('审批提交成功!');
        }
      }).finally(()=>{
        this.$hideLoading();
      })
    }

  },
  created() {
    this.initApprovePage()
  },
};



// WEBPACK FOOTER //
// ./src/page/reject/rejectApprovalShow/mixins/notification.js